import { createLink } from "@tanstack/react-router";
import * as React from "react";
import * as Headless from "@headlessui/react";
import { useShouldReload } from "@/app/Meta/utils/useBuildSha";

type BasicLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

function BaseLink(props: BasicLinkProps) {
  const { handleReloadClick } = useShouldReload();

  return (
    <Headless.DataInteractive>
      <a {...props} onClick={handleReloadClick(props.onClick)} />
    </Headless.DataInteractive>
  );
}

export const Link = createLink(BaseLink);
